module.exports = __webpack_public_path__ + "img/image8.697ab6ca.png";